import Repository from './Repository';
import { vue } from '../main';

const baseUrl = process.env.VUE_APP_API_URL;
const base = `${baseUrl}/chapter`;

export default {
  /**
     * Sets the current live timestamp to an existing chapter or entry within the currently acquired chaptering instance.
     * This endpoint only works when a live session is running.
     *
     * @param id
     * @param subId
     * @param timestamp
     * @returns {Promise<AxiosResponse<T>>}
     */
  setChapter(id, subId, timestamp = null) {
    return Repository.post(`${base}/set`, {
      id,
      subid: subId,
      timestamp,
    });
  },

  /**
     * Inserts a new entry within the current chapter within the currently acquired chaptering instance and sets the current live timestamp.
     * This endpoint only works when a live session is running.
     * If no gid parameter is given, an empty entry is added, which can later be replaced by api/chapter/replace.
     *
     * @returns {Promise<AxiosResponse<T>>}
     */
  insertEmptyChapter() {
    return Repository.post(`${base}/insert`);
  },

  /**
     * Inserts a new entry within the current chapter within the currently acquired chaptering instance and sets the current live timestamp.
     *
     * @param memberId
     * @param groupId
     * @returns {Promise<AxiosResponse<T>>}
     */
  insertChapterWithMemberAndGroup(memberId, groupId) {
    return Repository.post(`${base}/insert`, {
      gid: groupId,
      id: memberId,
    });
  },

  /**
     * Inserts a new entry within the current chapter within the currently acquired chaptering instance and sets the current live timestamp.
     *
     * @param eventId
     * @returns {Promise<AxiosResponse<T>>}
     */
  insertChapterFromEvent(eventId) {
    return Repository.post(`${base}/insert`, {
      eid: eventId,
    })
      .then(res => Promise.resolve(res))
      .catch(error => Promise.reject(error));
  },

  /**
     * Replaces the selected entry with the selected member.
     *
     * @param chapterId
     * @param entryId
     * @param groupId
     * @param memberId
     * @returns {Promise<AxiosResponse<T>>}
     */
  replaceEntry(chapterId, entryId, groupId, memberId) {
    if (entryId === null) return Promise.reject();

    return Repository.post(`${base}/replace`, {
      chid: chapterId,
      subid: entryId,
      gid: groupId,
      id: memberId,
    });
  },
};
